import { Routes } from 'config/routes';
import { DonationOutput } from 'gql/types';
import { Link } from 'modules/common/components';
import OutcomeCell from 'modules/donations/components/OutcomeCell';
import { getTranslation } from 'utils/getTranslation';

import { DonationCommentCell } from '../DonorDonationCommentCell';

const t = getTranslation('donor.DonorDonationCardInfo');

type Option = {
  label: string;
  value: JSX.Element | string;
};

type PropTypes = {
  donation: DonationOutput;
  canAddCommentsToDonation: boolean;
  productCategories?: Record<number, string>;
};

export const getOptions = ({
  donation,
  productCategories,
}: PropTypes): Option[] => {
  const isCellFilled =
    Boolean(donation.products?.length) || donation.ineligible;
  return [
    {
      label: t('donationId'),
      value: (
        <Link to={`${Routes.Donations}/${donation.shortId}`}>
          {donation.shortId}
        </Link>
      ),
    },
    {
      label: t('location'),
      value: donation.donor.location,
    },
    {
      label: t('comments'),
      value: <DonationCommentCell donation={donation} variant="card" />,
    },
    {
      label: t('products'),
      value: (
        <>
          {isCellFilled ? (
            <OutcomeCell
              donation={donation}
              productCategories={productCategories}
            />
          ) : (
            '-'
          )}
        </>
      ),
    },
  ];
};
